export interface GenericObject {
  [key: string]: string | null | number;
}

export enum CreatorCategoryEnum {
  "AllCategories" = "All Categories",
  "Academics" = "Academics",
  "Arts" = "Arts",
  "Coaching" = "Coaching",
  "Music" = "Music",
  "PersonalDevelopment" = "Personal Development",
  "Finance" = "Finance",
  "Technology" = "Technology",
  "Health" = "Health",
  "Business" = "Business",
  "Other" = "Other",
  "FinanceAndInvesting" = "Finance & Investing",
}

export enum ProductPageSlugEnum {
  courses = "create-and-sell-course-online",
  webinar = "conduct-live-webinars",
  membership = "launch-membership",
  digitalProducts = "sell-digital-products",
  // Enum key kept as `telegramCommunity` to minimize churn across ~15
  // call-sites; the slug/URL is now the generic community-chat page.
  telegramCommunity = "community-chat-for-creators",
  aiavatar = "ai-avatar",
  coaching = "sell-coaching-programs",
}

export enum FeaturePageSlugEnum {
  WebsiteBuilder = "ai-website-builder",
  MobileApp = "no-code-mobile-apps-for-creators",
  MarketingTools = "marketing-tools-for-creators",
  ChatCommunity = "community-chat-for-creators",
  SecureVideoStreaming = "secure-your-content",
  IntegratePaymentGateway = "accept-payments-for-creators",
  ThirdPartySupport = "integrations-in-graphy",
  aiavatar = "ai-avatar",
  aiagent = "ai-agent",
  aibrain = "ai-brain"
}

export enum AlternativePageSlugEnum {
  Kajabi = "kajabi-alternative",
  KajabiPricing = "kajabi-pricing",
  KajabiCoaching = "kajabi-coaching",
  KajabiReviews = "kajabi-reviews",
  Teachable = "teachable-alternative",
  Thinkific = "thinkific-alternative",
  Podia = "podia-alternative",
  Gumroad = "gumroad-alternative",
  Learnworlds = "learnworlds-alternative",
  Classplus = "classplus-alternative",
  Learnyst = "learnyst-alternative",
  Edmingle = "edmingle-alternative",
  Topmate = "topmate-alternative",
  CoursePlatformIndia = "course-platform-india",
}

export enum LegalPageSlugEnum {
  TermsOfService = "terms",
  PrivacyPolicy = "privacy",
  UserGuidelines = "user-guidelines",
  RefundPolicy = "refund-policy",
  AffiliateTerms = "affiliate",
  TakedownPolicy  = "takedown-policy",
  DataProcessingAddendum = "addendum",
  CookiesPolicy = "cookies",
  UkPrivacyRepresentation = "uk-privacy-representation",
  GdprRepresentation = "gdpr-representation",
}

export type SuccessStoryType = {
  name: string;
  category: CreatorCategoryEnum;
  description: string;
  designation: string;
  company: string;
  highlight: {
    main: string;
    subtext: string;
  };
  image: string;
  avatar: string;
  href: string;
  showOn: {
    home?: boolean;
    products?: {
      [key in ProductPageSlugEnum]?: {
        testimony: boolean;
        stories: boolean;
      };
    };
    features?: {
      [key in FeaturePageSlugEnum]?: {
        testimony: boolean;
        stories: boolean;
      };
    };
    pricing?: boolean;
    stories?: boolean;
  };
};

export enum OnboardingDestinationEnum {
  DigitalProducts = "digip",
  Courses = "courses",
  Memberships = "memberships",
  Webinars = "webinars",
  TelegramCommunity = "telegram",
  Home = "home",
  PricingLaunchMonthly = "pricing_launch_monthly",
  PricingLaunchYearly = "pricing_launch_yearly",
  PricingRiseMonthly = "pricing_rise_monthly",
  PricingRiseYearly = "pricing_rise_yearly",
  PricingScaleMonthly = "pricing_scale_monthly",
  PricingScaleYearly = "pricing_scale_yearly"
}
